var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 6.66658V8.33325H17.3327V6.66658H13.9993ZM12.3327 12.1749C13.1327 12.7666 14.1743 13.5499 14.9994 14.1666C15.3327 13.7249 15.666 13.2749 15.9993 12.8333C15.1743 12.2166 14.1327 11.4333 13.3327 10.8333C12.9994 11.2833 12.666 11.7333 12.3327 12.1749ZM15.9993 2.16659C15.666 1.72492 15.3327 1.27492 14.9994 0.833252C14.1743 1.44992 13.1327 2.23325 12.3327 2.83325C12.666 3.27492 12.9994 3.72492 13.3327 4.16659C14.1327 3.56659 15.1743 2.79159 15.9993 2.16659ZM2.33268 4.99992C1.41602 4.99992 0.666016 5.74992 0.666016 6.66658V8.33325C0.666016 9.24992 1.41602 9.99992 2.33268 9.99992H3.16602V13.3333H4.83268V9.99992H5.66602L9.83268 12.4999V2.49992L5.66602 4.99992H2.33268ZM11.916 7.49992C11.916 6.39159 11.4327 5.39158 10.666 4.70825V10.2833C11.4327 9.60825 11.916 8.60825 11.916 7.49992Z",
    fill: "#9BB8C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.3babfc4ae96e37138f91d55463356ddc.svg";
export { ForwardRef as ReactComponent };